<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import BroadcastEmployeePanel from '../../../../../../broadcasts/components/panels/BroadcastEmployeePanel.vue'

import { Broadcast } from '../../../../../../broadcasts/models/broadcast'
import { SiteID } from '../../../../../../sites/models/site'

definePage({
  props: true,
  meta: {
    requiresAuth: true,
    requiresOrganisation: true,
    hideLeftColumn: true,
    hideRightColumn: true,
  },
})

const { siteId, broadcast } = defineProps<{
  siteId: SiteID
  broadcast: Broadcast
}>()
</script>

<template>
  <BroadcastEmployeePanel :site-id="siteId" :broadcast="broadcast" />
</template>
